// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__EcF_I","address":"styles_address__W04fi"};